import { createFileRoute, notFound } from '@tanstack/react-router';
import { isUuid } from '@leanin/shared';
import { AdminShell } from '@/components/admin/AdminShell';
import { PLATFORM_ADMIN_ITEMS } from '@/components/admin/admin-sidebar-items';
import { EditBroadcastPage } from '@/components/broadcasts/EditBroadcastPage';

export const Route = createFileRoute('/_authed/admin/broadcasts/$id/edit')({
  beforeLoad: ({ params }) => {
    if (!isUuid(params.id)) throw notFound();
  },
  component: AdminEditBroadcastRoute,
});

function AdminEditBroadcastRoute() {
  const { id } = Route.useParams();
  return (
    <AdminShell items={PLATFORM_ADMIN_ITEMS} active="broadcasts">
      <EditBroadcastPage
        scope={{ kind: 'platform' }}
        broadcastId={id}
        audienceFromScope={{ mode: 'platform' }}
      />
    </AdminShell>
  );
}
